import { connect } from 'react-redux';
import { getCurrentUserHasCore, getIsLoggedIn } from '../../publicSession/selectors';
import { getIsUserDropdownOpen } from '../redux/selectors';
import { closeNotificationsDropdown } from '../redux/actions';
const mapStateToProps = (state)=>({
        isLoggedIn: getIsLoggedIn(state),
        isUserDropdownOpen: getIsUserDropdownOpen(state),
        hasCoreMembership: getCurrentUserHasCore(state)
    });
const mapDispatchToProps = {
    closeNotificationsDropdown
};
export default connect(mapStateToProps, mapDispatchToProps);
